import React from "react";
import { Sparkles, Hammer, Wrench, Palette, Clock, ArrowUpRight } from "lucide-react";
import { SERVICES, MEDIA } from "../data/content";

const ICONS = { Sparkles, Hammer, Wrench, Palette };

const SERVICE_IMAGES = {
  cleaning: MEDIA.hero_photo,
  restoration: MEDIA.workshop,
  repair: MEDIA.tools,
  painting: "https://images.pexels.com/photos/8899943/pexels-photo-8899943.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900",
};

const ACCENTS = {
  cleaning: "Кожа дышит снова.",
  restoration: "Возвращаем характер.",
  repair: "До последнего шва.",
  painting: "Точно в оттенок.",
};

const Services = ({ onSelectService }) => {
  return (
    <section id="services" className="section-y bg-cream-paper border-t-2 border-burgundy relative overflow-hidden" data-testid="services-section">
      {/* большая фоновая надпись-эхо */}
      <div className="pointer-events-none select-none absolute top-10 -right-10 font-heading text-[18vw] leading-none text-burgundy/5 hidden md:block">
        Услуги
      </div>

      <div className="container-x relative">
        <div className="max-w-4xl">
          <h2 className="font-heading text-5xl md:text-7xl lg:text-8xl heading-tight text-burgundy">
            Что мы умеем
            <br />
            <span className="accent text-ink">— и делаем хорошо.</span>
          </h2>
        </div>

        <div className="mt-20 md:mt-28 space-y-24 md:space-y-32">
          {SERVICES.map((s, idx) => {
            const Icon = ICONS[s.icon] || Sparkles;
            const flipped = idx % 2 === 1;
            return (
              <article
                key={s.slug}
                className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center"
                data-testid={`service-card-${s.slug}`}
              >
                {/* Image side */}
                <div className={`relative lg:col-span-6 ${flipped ? "lg:order-2" : ""}`}>
                  <div className={`absolute ${flipped ? "-right-5 -top-5" : "-left-5 -top-5"} w-full h-full border-2 border-burgundy -z-10`} />
                  <div className="relative bg-burgundy">
                    <img
                      src={SERVICE_IMAGES[s.slug]}
                      alt={s.title}
                      className="w-full h-[420px] md:h-[520px] object-cover mix-blend-multiply opacity-90"
                    />
                    {/* Цена-печать поверх */}
                    <div className="absolute bottom-5 left-5 md:bottom-7 md:left-7 bg-cream-paper border-2 border-burgundy px-5 py-3">
                      <div className="text-[10px] uppercase tracking-[0.3em] text-muted_ink font-bold">от</div>
                      <div className="font-heading text-3xl md:text-4xl text-burgundy leading-none">
                        {s.priceFrom.toLocaleString("ru-RU")} ₽
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content side */}
                <div className={`lg:col-span-6 ${flipped ? "lg:order-1 lg:pr-8" : "lg:pl-4"}`}>
                  <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 border-2 border-burgundy flex items-center justify-center text-burgundy">
                      <Icon size={26} strokeWidth={1.75} />
                    </div>
                    <div className="ornate-rule flex-1" />
                  </div>

                  <h3 className="font-heading text-5xl md:text-6xl lg:text-7xl heading-tight text-ink">
                    {s.title}
                  </h3>
                  <p className="accent text-burgundy text-2xl md:text-3xl mt-4 leading-snug">
                    {ACCENTS[s.slug]}
                  </p>
                  <p className="mt-6 body-rich text-ink/85 max-w-xl">
                    {s.description}
                  </p>

                  <div className="mt-10 flex items-center gap-5 md:gap-7 flex-wrap">
                    <div className="flex items-center gap-2 text-burgundy text-sm font-bold uppercase tracking-[0.18em]">
                      <Clock size={15} strokeWidth={2.25} />
                      {s.duration}
                    </div>
                    <button
                      onClick={() => onSelectService?.(s)}
                      className="group inline-flex items-center gap-3 text-burgundy font-bold uppercase tracking-[0.22em] text-xs md:text-sm hover:text-burgundy-deep transition-colors"
                      data-testid={`service-cta-${s.slug}`}
                    >
                      <span className="border-b-2 border-burgundy pb-1">Заказать услугу</span>
                      <ArrowUpRight size={20} strokeWidth={2} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </button>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
